import './App.css';
import CalculadoraHidratos from './components/CalculadoraHidratos';
import { signInWithPopup, signInWithRedirect } from "firebase/auth";
import { auth, provider } from "./firebase";

function App() {
  const loginWithGoogle = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.error("Error logging in:", error);
    }
  };

  return (
    <div className="App">
      <CalculadoraHidratos />
    </div>
  );
}

export default App;